module.exports = __webpack_public_path__ + "img/square_header_3new.da7a47cb.png";